var _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBinRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ee5d5d",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M316.325,44.522V0H195.68l-0.003,44.522H61.217v87.982h21.616c3.975,75.409,20.548,350.983,21.319,363.803L105.097,512 h301.806l0.944-15.694c0.771-12.821,17.345-288.394,21.319-363.803h21.616V44.522H316.325z M229.069,33.391h53.866v11.13h-53.866 V33.391z M375.458,478.609H136.542c-3.633-60.548-16.681-278.597-20.27-346.105h279.456 C392.14,200.012,379.091,418.06,375.458,478.609z M417.391,99.112H94.609V77.913h322.783V99.112z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 239.304,
    y: 167.947,
    width: 33.391,
    height: 280.031
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 160.292,
    y: 168.19,
    transform: "matrix(0.9986 -0.0521 0.0521 0.9986 -15.8157 9.64)",
    width: 33.39,
    height: 279.952
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 195.052,
    y: 291.462,
    transform: "matrix(0.0521 -0.9986 0.9986 0.0521 9.8344 626.6741)",
    width: 279.952,
    height: 33.39
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinRed);
export default __webpack_public_path__ + "static/media/bin-red.7e27932a690eb024c416a6246d04d5f8.svg";
export { ForwardRef as ReactComponent };